define('views/modules/template/assignment/list/per-user/per-user-assignment-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/fetch-list',
    'views/modules/template/assignment/list/per-user/per-user-assignment-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VFetchList,
    VPerUserAssignmentListItem
) {

    var VPerUserAssignmentList = VFetchList.extend({
        item: VPerUserAssignmentListItem
    });

    return VPerUserAssignmentList;
});

